
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./WaterTreatment.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";

import { trackPageVisit } from "../competency/PageTracker";

 

 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function WaterTreatment() {

        useEffect(() => {
  
    trackPageVisit("WaterTreatment");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);

  


  const DEFAULT_VALVES = {
  FCV_2941: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2942: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2943: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2944: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("WaterTreatment_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2941: { ...DEFAULT_VALVES.FCV_FCV_2941, ...parsed.FCV_2941 },
      FCV_2942: { ...DEFAULT_VALVES.FCV_FCV_2942, ...parsed.FCV_2942 },
      FCV_2943: { ...DEFAULT_VALVES.FCV_FCV_2943, ...parsed.FCV_2943 },
      FCV_2944: { ...DEFAULT_VALVES.FCV_FCV_2944, ...parsed.FCV_2944 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("WaterTreatment_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  
  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};









  const FIC_2941 = 6.654;
  const PT_2941 = 0.354;


  // ================= TT_2941 TEMPERATURE INPUT =================
const [TT_2941, setTT_2941] = useState(() => {
  return Number(localStorage.getItem("TT_2941")) || 25; // default 25°C
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("TT_2941", TT_2941);
}, [TT_2941]);

const [ttPosition, setTTPosition] = useState({ x: 305, y: 527 });

// ================= PDT_2941 (FOULING FACTOR - SEAWATER STRAINER) =================
const [PDT_2941, setPDT_2941] = useState(() => {
  return Number(localStorage.getItem("PDT_2941")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("PDT_2941", PDT_2941);
}, [PDT_2941]);

const [pdt2941Position, setPdt2941Position] = useState({ x: 640, y: 270 }); // 🔧 adjust freely

// ================= PDT_2942 (FOULING FACTOR - SEAWATER STRAINER) =================
const [PDT_2942, setPDT_2942] = useState(() => {
  return Number(localStorage.getItem("PDT_2942")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("PDT_2942", PDT_2942);
}, [PDT_2942]);

const [pdt2942Position, setPdt2942Position] = useState({ x: 840, y: 270 }); // 🔧 adjust freely


// ================= PDT_2943 (FOULING FACTOR - SEAWATER STRAINER) =================
const [PDT_2943, setPDT_2943] = useState(() => {
  return Number(localStorage.getItem("PDT_2943")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("PDT_2943", PDT_2943);
}, [PDT_2943]);

const [pdt2943Position, setPdt2943Position] = useState({ x: 955, y: 270 }); // 🔧 adjust freely





const DOT_2941 = 8;






// ================= PUMP CONTEXT =================
const { pumpData } = useContext(PumpContext);

// ================= PUMP STATUS =================
const isP2941AOn = pumpData?.["P-2941A"]?.running ?? false;
const isP2941BOn = pumpData?.["P-2941B"]?.running ?? false;

const runningPumps2941 = [isP2941AOn, isP2941BOn].filter(Boolean).length;

// ================= VALVE OPENING =================
const valveOpening2942 = Math.max(
  0,
  Math.min(100, Number(valveData?.FCV_2942?.opening || 0))
);

// ================= DESIGN LIMITS =================
const MAX_FLOW_2942 = 250;
const MAX_PRESSURE_2942 = 1.8;
const MIN_PRESSURE_2942 = 0.03;
const BASE_TEMP_OFF = 22;

// ================= TARGET VALUES =================

// FLOW → proportional to valve opening
const targetFlow2942 =
  runningPumps2941 > 0
    ? MAX_FLOW_2942 * (valveOpening2942 / 100)
    : 0;

// 🔥 PRESSURE → inverse to valve opening (restriction effect)
const targetPressure2942 =
  runningPumps2941 > 0
    ? MIN_PRESSURE_2942 +
      (1 - valveOpening2942 / 100) * (MAX_PRESSURE_2942 - MIN_PRESSURE_2942)
    : MIN_PRESSURE_2942;

// 🔥 TEMPERATURE → also inverse + process heating contribution
const baseTempFromProcess =
  Number(TT_2941) + (Number(TT_2941) * 0.1092);

// inverse effect (valve restriction heating)
const restrictionBoost =
  (1 - valveOpening2942 / 100) * 12; // 🔥 tune (increase for stronger effect)

const targetTemp2942 =
  runningPumps2941 > 0
    ? baseTempFromProcess + restrictionBoost
    : BASE_TEMP_OFF;

// ================= STATES =================
const [FIC_2942, setFIC_2942] = useState(0);
const [PT_2942, setPT_2942] = useState(0.03);
const [TT_2942, setTT_2942] = useState(22);

// ================= SMOOTH RESPONSE =================
useEffect(() => {
  const interval = setInterval(() => {

    // FLOW (fast)
    setFIC_2942(prev => {
      const next = prev + (targetFlow2942 - prev) * 0.2;
      return Number(next.toFixed(2));
    });

    // PRESSURE (medium-fast)
    setPT_2942(prev => {
      const next = prev + (targetPressure2942 - prev) * 0.18;
      return Number(next.toFixed(3));
    });

    // TEMPERATURE (slightly slower but responsive)
    setTT_2942(prev => {
      const next = prev + (targetTemp2942 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast DCS feel

  return () => clearInterval(interval);

}, [targetFlow2942, targetPressure2942, targetTemp2942]);

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("FIC_2942", FIC_2942);
  localStorage.setItem("PT_2942", PT_2942);
  localStorage.setItem("TT_2942", TT_2942);
}, [FIC_2942, PT_2942, TT_2942]);

const isXV2941Open = valves?.XV_2941 === false;

const PT_2943 = PT_2942 - PDT_2941;
const PT_2944 = PT_2943 + PDT_2942;
const PT_2945 = PT_2944 + PDT_2943;

const FIC_2947 = 20 * (valveData?.FCV_2943?.opening || 0)/100;
const PT_2947 = 0.8 * (valveData?.FCV_2943?.opening || 0)/100;

const FIC_2948 = isXV2941Open ? 2.12 : 0;
const PT_2948 = isXV2941Open ? 0.232 : 0.03;

const FIC_2945 = FIC_2942/2 * (valveData?.FCV_2941?.opening || 0)/100;
const PT_2946 = PT_2943*1.2 * (valveData?.FCV_2941?.opening || 0)/100;

const FIC_2949 = FIC_2942/2 * (valveData?.FCV_2944?.opening || 0)/100;
const PT_2949 = PT_2943*1.2 * (valveData?.FCV_2944?.opening || 0)/100;


const FIC_2943 = FIC_2942 - (FIC_2945+FIC_2949) -(PDT_2941);

const FIC_2944 = (FIC_2943 - (PDT_2942) - (PDT_2943));



// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("FIC_2944", FIC_2944);
  localStorage.setItem("FIC_2945", FIC_2945);
  localStorage.setItem("FIC_2947", FIC_2947);
  localStorage.setItem("FIC_2948", FIC_2948);
  localStorage.setItem("PT_2945", PT_2945);
  localStorage.setItem("PT_2947", PT_2947);
  localStorage.setItem("PT_2948", PT_2948);
  localStorage.setItem("PT_2946", PT_2946);
  localStorage.setItem("TT_2942", TT_2942);
  localStorage.setItem("DOT_2941", DOT_2941);

}, [FIC_2944, FIC_2945, FIC_2947, FIC_2948, PT_2945, PT_2946, PT_2947, PT_2948, DOT_2941, TT_2942,]);





  return (
    <div className="WaterTreatment-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "244px",
        color: "white",
        background: "rgb(29, 4, 250)", 
        padding: "2px 317px"
      }}>
        SEAWATER TREATMENT
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2931 */}
      <Valve
        className="XV-2941"
        tag="XV_2941"
        x={1213}
        y={77}
        isClosed={valves.XV_2941}
        toggle={toggleValve}
      />


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2941 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2941"
          style={{ position: "absolute", left: 275, top: 97}}  onClick={() => openPanel("FCV_2941")}>
          
          <defs>
            <linearGradient id="metal_2941">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2941)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2941)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-2942 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2942"
          style={{ position: "absolute", left: 1076, top: 257 }}  onClick={() => openPanel("FCV_2942")}>
          
          <defs>
            <linearGradient id="metal_2942">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2942)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2942)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>


        {/* FCV-2943 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2943"
          style={{ position: "absolute", left: 1158, top: 520 }}  onClick={() => openPanel("FCV_2943")}>
          
          <defs>
            <linearGradient id="metal_2943">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2943)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2943)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          

        {/* FCV-2944 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2944"
          style={{ position: "absolute", left: 279, top: 595 }}  onClick={() => openPanel("FCV_2944")}>
          
          <defs>
            <linearGradient id="metal_2944">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2944)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2944)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
       {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2941?.opening || 0)}
        x={288}
        y={142}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2942?.opening || 0)}
        x={1099}
        y={305}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2943?.opening || 0)}
        x={1182}
        y={571}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2944?.opening || 0)}
        x={305}
        y={638}
      />


          {/* ================= TRANSMITTERS OUTPUTS ================= */}
      
        <Transmitter
          tag="FIC-2941"
          value={[FIC_2941]}
          x={148}
          y={384}
          unit="LPM"
          max={10}
          HH={9}
          H={8}
          L={1}
          LL={0.5}
          c="lime"
          description="FLOWRATE OF HYPERCHLORINATED WATER FROM HYPOCHLORITE GENERATOR TO SEA WATER PUMP SUNCTION"
        />

         <Transmitter
          tag="PT-2941"
          value={PT_2941}
          x={148}
          y={436}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF HYPERCHLORINATED WATER FROM HYPOCHLORITE GENERATOR TO SEA WATER PUMP SUNCTION"
        />

        <Transmitter
          tag="TT-2941"
          value={TT_2941}
          x={302}
          y={430}
          unit="°C"
          max={150}
          HH={120}
          H={100}
          L={20}
          LL={5}
          c="lime"
          description="MANUAL TEMPERATURE INPUT OF SEA WATER IN OFFSHORE FOR PROCESS CONTROL ON SEAWATER TREATMENT"
        />

        <Transmitter
          tag="FIC-2942"
          value={[FIC_2942]}
          x={478}
          y={264}
          unit="LPM"
          max={300}
          HH={280}
          H={250}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF SEAWATER AT DISCHARGE OF SEAWATER PUMPS TO SEAWATER STRAINERS"
        />

         <Transmitter
          tag="PT-2942"
          value={PT_2942}
          x={550}
          y={264}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT DISCHARGE OF SEAWATER PUMPS TO SEAWATER STRAINERS"
        />

        <Transmitter
          tag="TT-2942"
          value={TT_2942}
          x={518}
          y={319}
          unit="°C"
          max={50}
          HH={45}
          H={40}
          L={20}
          LL={5}
          c="lime"
          description="TEMPERATURE SEAWATER AT DISCHARGE OF SEAWATER PUMPS TO SEAWATER STRAINERS"
        />


        
        <Transmitter
          tag="FIC-2943"
          value={[FIC_2943]}
          x={717}
          y={319}
          unit="LPM"
          max={300}
          HH={280}
          H={250}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF SEAWATER AT DISCHARGE OF SEAWATER PUMPS AND DISCHARGE OF SEAWATER STRAINERS"
        />

         <Transmitter
          tag="PT-2943"
          value={PT_2943}
          x={702}
          y={264}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT DISCHARGE OF SEAWATER PUMPS AND DISCHARGE OF SEAWATER STRAINERS"
        />
         <Transmitter
          tag="PT-2944"
          value={PT_2944}
          x={878}
          y={264}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT DISCHARGE OF SEAWATER PUMPS AND DISCHARGE OF SEAWATER SAND FILTERS"
        />
         <Transmitter
          tag="PT-2945"
          value={PT_2945}
          x={1018}
          y={317}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT DISCHARGE OF SEAWATER PUMPS AND DISCHARGE OF SEAWATER GUARD FILTERS"
        />

        
        <Transmitter
          tag="FIC-2944"
          value={[FIC_2944]}
          x={1018}
          y={268}
          unit="LPM"
          max={300}
          HH={280}
          H={250}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF SEAWATER AT DISCHARGE OF SEAWATER PUMPS AND DISCHARGE OF SEAWATER GUARD FILTERS"
        />

         <Transmitter
          tag="PT-2946"
          value={PT_2946}
          x={550}
          y={94}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT DISCHARGE OF SEAWATER STRAINERS TO HYPOCHLORITE GENERATOR"
        />
                 
        <Transmitter
          tag="FIC-2945"
          value={[FIC_2945]}
          x={473}
          y={94}
          unit="LPM"
          max={300}
          HH={280}
          H={250}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF SEAWATER AT DISCHARGE OF SEAWATER STRAINERS TO HYPOCHLORITE GENERATOR"
        />
        
        <Transmitter
          tag="FIC-2949"
          value={[FIC_2949]}
          x={456}
          y={596}
          unit="LPM"
          max={300}
          HH={280}
          H={250}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF SEAWATER AT DISCHARGE OF SEAWATER STRAINERS AND BACKWATCHED TO SEA"
        />

        <Transmitter
          tag="PT-2949"
          value={PT_2949}
          x={535}
          y={596}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT DISCHARGE OF SEAWATER STRAINERS AND BACKWATCHED TO SEA"
        />

        
        <Transmitter
          tag="FIC-2947"
          value={[FIC_2947]}
          x={1069}
          y={476}
          unit="LPM"
          max={30}
          HH={28}
          H={20}
          L={2}
          LL={0.5}
          c="lime"
          description="FLOWRATE OF CORROSION INHIBITOR TO SEAWATER TREATMENT LINE AT DISCHARGE OF GUARD FILTER TO VACUUM DEARATOR"
        />

        <Transmitter
          tag="PT-2947"
          value={PT_2947}
          x={1080}
          y={416}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF CORROSION INHIBITOR TO SEAWATER TREATMENT LINE AT DISCHARGE OF GUARD FILTER TO VACUUM DEARATOR"
        />

        
        <Transmitter
          tag="FIC-2948"
          value={[FIC_2948]}
          x={1142}
          y={66}
          unit="LPM"
          max={5}
          HH={2.5}
          H={2}
          L={0.5}
          LL={0.1}
          c="lime"
          description="FLOWRATE OF BIOCIDE INHIBITOR TO SEAWATER TREATMENT LINE AT DISCHARGE OF GUARD FILTER TO VACUUM DEARATOR"
        />

        <Transmitter
          tag="PT-2948"
          value={PT_2948}
          x={1068}
          y={146}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF BIOCIDE INHIBITOR TO SEAWATER TREATMENT LINE AT DISCHARGE OF GUARD FILTER TO VACUUM DEARATOR"
        />

















          <Transmitter
          tag="PDT-2941"
          value={PDT_2941}
          x={615}
          y={225}
          unit="bar"
          max={5}
          HH={4}
          H={3}
          L={0.2}
          LL={0.05}
          c="lime"
          description="FOULING FACTOR - SEAWATER STRAINER"
        />
        

        <Transmitter
          tag="PDT-2942"
          value={PDT_2942}
          x={795}
          y={216}
          unit="bar"
          max={5}
          HH={4}
          H={3}
          L={0.2}
          LL={0.05}
          c="lime"
          description="FOULING FACTOR - SAND FILTER"
        />

        <Transmitter
          tag="PDT-2943"
          value={PDT_2943}
          x={938}
          y={216}
          unit="bar"
          max={5}
          HH={4}
          H={3}
          L={0.2}
          LL={0.05}
          c="lime"
          description="FOULING FACTOR - GUARD FILTER"
        />


        <Transmitter
          tag="DOT-2941"
          value={DOT_2941}
          x={401}
          y={431}
          unit="ppm"
          max={10}
          HH={9}
          H={8.5}
          L={0.2}
          LL={0.05}
          c="lime"
          description="DISSOLVED OXYGEN LEVEL TRANSMITER FOR SEAWATER BEFORE TREATMENT"
        />



        
    <Pump
      tag="P-2941A"
      x={239}
      y={220}
      rpm={1800}
      bladeCount={pumpData?.["P-2941A"]?.bladeCount || 3}
      size={pumpData?.["P-2941A"]?.size || 38}
      onClick={openPumpPanel}
    />

  
    <Pump
      tag="P-2941B"
      x={365}
      y={220}
      rpm={1800}
      bladeCount={pumpData?.["P-2941B"]?.bladeCount || 3}
      size={pumpData?.["P-2941B"]?.size || 38}
      onClick={openPumpPanel}
    />










        
      
                  <div
                      className="tt2941-input-group"
                      style={{
                        position: "absolute",
                        left: ttPosition.x,
                        top: ttPosition.y,
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        zIndex: 1000
                      }}
                    >
                  <input
                    type="number"
                    className="tt2941-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",   // 🔥 change from red so you see it properly
                      color: "lightGrey",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={TT_2941}
                    onChange={(e) => setTT_2941(Number(e.target.value) || 0)}
                  />

                </div>

                
                <div
                  className="pdt2941-input-group"
                  style={{
                    position: "absolute",
                    left: pdt2941Position.x,
                    top: pdt2941Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="pdt2941-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "lightGrey",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={PDT_2941}
                    onChange={(e) => setPDT_2941(Number(e.target.value) || 0)}
                  />
                </div>

 
                
                <div
                  className="pdt2942-input-group"
                  style={{
                    position: "absolute",
                    left: pdt2942Position.x,
                    top: pdt2942Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="pdt2942-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "lightGrey",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={PDT_2942}
                    onChange={(e) => setPDT_2942(Number(e.target.value) || 0)}
                  />
                </div>
                
                <div
                  className="pdt2943-input-group"
                  style={{
                    position: "absolute",
                    left: pdt2943Position.x,
                    top: pdt2943Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="pdt2943-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "lightGrey",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={PDT_2943}
                    onChange={(e) => setPDT_2943(Number(e.target.value) || 0)}
                  />
                </div>

 

    </div>
  );
}

export default WaterTreatment;